import { StrapiField } from "~/types/strapi";

export function getFieldDefaultModel(field: StrapiField): string | undefined {
  return field?.options?.find((o) => o.default)?.value;
}

export function getCheckboxGroupDefaultModel(field: StrapiField): string[] {
  return field?.options?.filter((o) => o.default).map((el) => el.value) || [];
}
